import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var Alert = function Alert(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.06738 22.0674H20.9219C22.5869 22.0674 23.6611 20.832 23.6611 19.3174C23.6611 18.8662 23.543 18.4043 23.3066 17.9746L14.8633 2.89258C14.3477 1.95801 13.4238 1.48535 12.5 1.48535C11.5762 1.48535 10.6416 1.95801 10.126 2.89258L1.69336 17.9746C1.45703 18.415 1.32812 18.8662 1.32812 19.3174C1.32812 20.832 2.40234 22.0674 4.06738 22.0674ZM12.5107 14.6768C11.877 14.6768 11.5117 14.3223 11.4902 13.6885L11.3398 8.31738C11.3184 7.65137 11.791 7.18945 12.5 7.18945C13.1875 7.18945 13.6924 7.66211 13.6709 8.32812L13.499 13.6777C13.4775 14.333 13.123 14.6768 12.5107 14.6768ZM12.5107 18.3936C11.7803 18.3936 11.1787 17.8672 11.1787 17.1582C11.1787 16.4492 11.7695 15.9229 12.5107 15.9229C13.2412 15.9229 13.832 16.4492 13.832 17.1582C13.832 17.8779 13.2305 18.3936 12.5107 18.3936Z"
  })));
};

Alert.displayName = 'Alert';
export default Alert;